import React, {FC} from 'react';
import styled from 'styled-components';

import {ContactCardPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {Dropdown} from '../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {PopoverTransferProps} from '../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {VisualContactModel} from '../../models/api/visualContactModel';
import {ContactCardLocationsEnum} from '../../store/panels/contacts/contactCard/contactCardPanelState';
import {ContactCardDetailsContainer} from './details/contactCardDetailsContainer';
import {ContactCardFooterContainer} from './footer/contactCardFooterContainer';
import {ContactCardHeaderContainer} from './header/contactCardHeaderContainer';

/*
 * Constants.
 */

const dropdownWidth = 300; // px.

/*
 * Props.
 */

export interface ContactCardProps {
  panelId: ContactCardPanelId;
  popoverProps: PopoverTransferProps;
  visualContact: VisualContactModel;
  location: ContactCardLocationsEnum;
  isUnverified?: boolean;
  isUserVisitor?: boolean;
}

/*
 * Style.
 */

const StyledContactCardDetailsWrapperDiv = styled.div`
  display: grid;
  row-gap: 10px;
  grid-template-columns: auto 1fr;
  overflow: auto;
  padding: 6px 16px 16px 16px;
`;

const StyledDropdown = styled(Dropdown)`
  border-radius: 16px;
`;

/*
 * Component.
 */

export const ContactCard: FC<ContactCardProps> = (props) => {
  const {panelId, popoverProps, visualContact, isUnverified, isUserVisitor, location} = props;

  return (
    <StyledDropdown {...popoverProps} width={dropdownWidth}>
      <ContactCardHeaderContainer
        panelId={panelId}
        visualContact={visualContact}
        isUnverified={isUnverified}
        isUserVisitor={Boolean(isUserVisitor)}
      />
      <StyledContactCardDetailsWrapperDiv>
        <ContactCardDetailsContainer panelId={panelId} visualContact={visualContact} location={location} />
      </StyledContactCardDetailsWrapperDiv>
      {maybeRenderContactCardFooter(props)}
    </StyledDropdown>
  );
};

/*
 * Helpers.
 */

function maybeRenderContactCardFooter(props: ContactCardProps) {
  const {panelId, visualContact, isUserVisitor} = props;

  if (isUserVisitor) {
    return null;
  }
  return <ContactCardFooterContainer panelId={panelId} visualContact={visualContact} />;
}
